import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'
export default class CodeGenerator extends ApiCore {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/cgs'
    super(store, path)
  }

  download(model, showProgress) {
    return this._request({
      action: 'create',
      method: 'POST',
      body: model,
      responseType: 'blob',
      showProgress
    })
  }
}
